








import Vue from 'vue'

import WithTag from '@/components/WithTag'
import EditorMixin from './EditorMixin'
import _ from 'lodash'

const Editor = Vue.extend({
  components: { WithTag },
  mixins: [EditorMixin],
  props: {
    tag: {
      default: 'div',
      type: String,
    },
    saveWith: {
      type: Function,
      default: editCopy => editCopy,
    },
    autoSaveEvery: {
      type: Number,
    },
  },
  created() {
    if (this.autoSaveEvery) {
      const timedSaver = _.throttle(
        (copy: object) => this.saveFunction(copy),
        this.autoSaveEvery
      )
      this.$on('input', timedSaver)
    }
  },
  methods: {
    saveFunction(editCopy: object) {
      return this.saveWith(editCopy)
    },
  },
})

export default Editor
